<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("jwt key") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.jwt_key"
              :placeholder="$t('jwt key')"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("expire time") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.expire_time"
              placeholder="8d, 3h, 30m, ..."
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("header name") }}</label>
          <div class="control">
            <input
              type="text"
              class="input"
              v-model="meta.header_name"
              placeholder="x-header-name"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="buttons is-pulled-right">
      <div class="button is-secondary is-rounded" @click="add">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add") }}</span>
      </div>
    </div>
    <h5 class="title is-5 pt-3">{{ $t("tokens") }}</h5>
    <table class="table is-bordered is-fullwidth">
      <thead>
        <tr>
          <th>{{ $t("token") }}</th>
          <th>{{ $t("description") }}</th>
          <th>{{ $t("expire time") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rsrc, ridx) in meta.tokens" :key="ridx">
          <td>
            <input
              type="text"
              class="input"
              v-model="meta.tokens[ridx].token"
            />
          </td>
          <td>
            <input
              type="text"
              class="input"
              v-model="meta.tokens[ridx].description"
            />
          </td>
          <td>{{ rsrc.expire_time }} - {{ rsrc.create_date }}</td>
          <td>
            <div
              class="button is-secondary has-text-danger is-rounded"
              @click="meta.tokens.splice(ridx, 1)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { put } from "@/utils";
import moment from "moment";
export default {
  name: "JWT",
  data() {
    return {
      meta: { tokens: [], jwt_key: "", expire_time: "", header_name: "" },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      let v = this;
      Object.keys(data).map((k) => {
        v.meta[k] = data[k];
      });
    },
    clear() {
      this.meta = {
        tokens: [],
      };
    },
    add() {
      let v = this;
      put("/api/security/jwt", {
        expire_time: v.meta.expire_time,
        jwt_key: v.meta.jwt_key,
      })
        .then((r) => {
          console.log(r);
          v.meta.tokens.push({
            token: r,
            description: "",
            expire_time: v.meta.expire_time,
            create_date: moment(),
          });
        })
        .catch((err) => {
          v.$emit("error", err);
        });
    },
  },
};
</script>
